import * as React from 'react';

import {colors} from '../colors/colors';
import {StatusBadge} from '../status-badge/status-badge';
import {Header} from '../typography/header';

import styles from './onboarding-body.module.css';

type IconProps = {
    icon: React.ComponentType<any>;
    color?: string;
};

type Props = {
    title: string | React.ReactElement<React.ComponentProps<'span'>>;
    children: React.ReactNode;
    style?: any;
    statusText?: string;
    iconProps?: IconProps;
};

export function OnboardingBody({title, children, style, statusText, iconProps}: Props) {
    const renderIcon = () => {
        if (iconProps) {
            const {icon: Icon, color = colors.greyDk} = iconProps;

            return (
                <Icon wrapWithDiv={false} size={36} alignCenter={true} color={color} fill={color} />
            );
        }
    };

    return (
        <div style={style} className={styles['main-content']}>
            {iconProps && renderIcon()}
            {statusText ? (
                <div className={styles.status}>
                    <StatusBadge level='info' text={statusText} />
                </div>
            ) : null}
            <Header>{title}</Header>
            {children}
        </div>
    );
}
